import { pxToRem, responsiveFontSize, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, text } = theme;

export const textButton = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${responsiveFontSize(text.xs)};

  width: 100%;
  padding: 0;
  background: none;
  border: none;
  color: black;
  text-decoration: underline;

  ${/* used for focus styles */ ''}
  border-radius: ${pxToRem(4)};
`;
